<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Dados da reunião da comissão."
    closeAriaLabel="Fechar"
    [header]="titulo"
    [visible]="visivel()"
    (visibleChange)="visivel.set($event)"
    [style]="{ width: 'min(46rem, calc(100vw - 2rem))' }"
    styleClass="dialogo-reuniao-custom"
    appendTo="body"
    (onHide)="fechar()"
>
    <form [formGroup]="formulario" class="flex flex-col gap-6 py-2">
        <!-- Seção: Informações da reunião -->
        <app-card-content [icon]="'pi pi-clock'" [title]="'Informações da reunião'">
            <div class="flex flex-col gap-4">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div class="flex flex-col gap-1.5">
                        <label for="dataReuniao" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Data <span class="text-red-500">*</span></label>
                        <input id="dataReuniao" pInputText type="date" formControlName="dataReuniao" class="w-full" />
                    </div>
                    <div class="flex flex-col gap-1.5">
                        <label for="horaInicio" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Hora de início <span class="text-red-500">*</span></label>
                        <input id="horaInicio" pInputText type="time" formControlName="horaInicio" class="w-full" />
                    </div>
                    <div class="flex flex-col gap-1.5">
                        <label for="horaFim" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Hora de término <span class="text-red-500">*</span></label>
                        <input id="horaFim" pInputText type="time" formControlName="horaFim" class="w-full" />
                    </div>
                </div>
                @if (formulario.controls.horaFim.hasError('periodoInvalido')) {
                    <small class="text-xs text-red-600 dark:text-red-500 font-semibold mt-0.5">A hora de término não pode ser menor que a hora de início.</small>
                }

                <label class="check-linha flex items-center gap-2 text-sm font-semibold select-none cursor-pointer mt-1">
                    <p-checkbox formControlName="inVisivelPortal" [binary]="true"></p-checkbox>
                    <span>Visível no Portal</span>
                </label>
            </div>
        </app-card-content>

        <!-- Seção: Informações adicionais -->
        <app-card-content [icon]="'pi pi-info-circle'" [title]="'Informações adicionais'">
            <div class="flex flex-col gap-4">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div class="flex flex-col gap-1.5">
                        <label for="inModalidade" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Modalidade <span class="text-red-500">*</span></label>
                        <p-select id="inModalidade" class="w-full" styleClass="w-full" formControlName="inModalidade" [options]="modalidades" optionLabel="label" optionValue="value" appendTo="body"></p-select>
                    </div>
                    <div class="flex flex-col gap-1.5">
                        <label for="idLocalReuniao" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Local <span class="text-red-500">*</span></label>
                        <p-select id="idLocalReuniao" class="w-full" styleClass="w-full" formControlName="idLocalReuniao" [options]="opcoesLocais" optionLabel="label" optionValue="value" appendTo="body"></p-select>
                    </div>
                </div>

                <div class="grid grid-cols-1 gap-4">
                    <div class="flex flex-col gap-1.5">
                        <label for="idTipoComissaoCt" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Tipo <span class="text-red-500">*</span></label>
                        <p-select id="idTipoComissaoCt" class="w-full" styleClass="w-full" formControlName="idTipoComissaoCt" [options]="opcoesTipos" optionLabel="label" optionValue="value" (onChange)="aoAlterarTipo()" appendTo="body"></p-select>
                        @if (formulario.controls.idTipoComissaoCt.touched && formulario.controls.idTipoComissaoCt.invalid) {
                            <small class="text-xs text-red-600 dark:text-red-500 font-semibold mt-0.5">Informe o tipo.</small>
                        }
                    </div>

                    <div class="flex flex-col gap-1.5">
                        <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Comissão/Câmara Técnica/Grupo de Trabalho <span class="text-red-500">*</span></label>
                        <app-seletor-arvore-comissao
                            formControlName="idEstruturaOrganizacional"
                            [tiposComissao]="tiposComissao()"
                            [estruturasComissao]="estruturasComissao()"
                            [idTipoComissaoCt]="formulario.controls.idTipoComissaoCt.value"
                            [carregando]="carregandoEstruturas()"
                            placeholder="Selecione"
                        ></app-seletor-arvore-comissao>
                        @if (formulario.controls.idEstruturaOrganizacional.touched && formulario.controls.idEstruturaOrganizacional.invalid) {
                            <small class="text-xs text-red-600 dark:text-red-500 font-semibold mt-0.5">Informe a comissão/câmara/grupo.</small>
                        }
                    </div>
                </div>
            </div>
        </app-card-content>
    </form>

    <ng-template pTemplate="footer">
        <div class="rodape-dialogo pt-2">
            <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="fechar()"></button>
            <button type="button" pButton label="Salvar" severity="primary" [disabled]="formulario.invalid" (click)="confirmar()" [appCan]="roleConfirmar"></button>
        </div>
    </ng-template>
</p-dialog>
